<template>
  <div id="app">
    <router-view />
    <svg-icon></svg-icon>
  </div>
</template>

<script>
import svgIcon from "@/components/svg";
export default {
  name: "App",
  components: { svgIcon },
};
</script>

<style lang="scss">
#app {
  background-color: #efefef;
  //导出中的加载环
  .myProgressBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 99;

    .myProgress {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  //按钮样式
  .el-button {
    font-size: 14px;
    padding: 8px 15px;

    svg {
      position: relative;
      margin-right: 5px;
      top: 3px;
      width: 18px;
      height: 18px;
    }
  }
  //primary按钮颜色设置
  .el-button--primary {
      background-color: #1677ff !important;
      border-color: #1677ff !important;
      color: #fff;
    }
  //页码色设置
  .el-pager li:not(.disabled).active {
    background-color: #1677ff !important;
  }
  //日期选中颜色设置
  .el-date-table td.start-date span {
    background-color: #1677ff !important;
  }
  /** { touch-action: none; }*/
  [class^="el-icon-fa"],
  [class*=" el-icon-fa"] {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /*表格*/
  .el-table {
    margin-top: 10px;

    td,
    th {
      font-size: 12px;
      padding: 0px;
    }

    .cell {
      text-align: center !important;
    }

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #fff;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track {
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
      -webkit-border-radius: 10px;
      border-radius: 10px;
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #ccc;
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.8);
    }

    ::-webkit-scrollbar-thumb:window-inactive {
      background: #ccc;
    }
  }

  /* 表格 */
  .el-table {
    div,
    span {
      font-size: 14px;
    }

    &.el-table--border,
    .el-table--group {
      border-color: #efefef;
    }

    &:before {
      background: #efefef;
    }

    .el-table__fixed-right::before,
    .el-table__fixed::before {
      background-color: #efefef;
    }
  }

  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right-color: #efefef;
    border-bottom-color: #efefef;
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: #efefef;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom-color: #efefef;
  }

  .el-table--border th.gutter:last-of-type {
    border-bottom-color: #efefef;
  }

  .el-table td {
    color: #595757;
    /* 设置td字号颜色 */
    padding: 5px 0;
  }

  .el-table th {
    background-color: #f4f0ff;
    /* 设置表头背景颜色 */
    height: 40px;
    /* 设置表头高度 */
    line-height: 40px;
    /* 设置表头行高 */
    color: #141414;
  }

  /* 表单 */
  .el-form {
    .el-form-item {
      margin-bottom: 5px;

      .el-form-item__label {
        color: #141414;
        max-width: 200px;
        padding-right: 0;
      }
    }

    .el-input {
      // max-width: 250px;
    }

    /* search */
    &.gm_search {
      .el-input {
        width: 140px;
      }

      /* 设置input的宽度 */
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }

      /* 设置input的宽度 */
      .el-form--inline .el-form-item {
        margin-right: 8px;
      }

      /* 设置input的宽度 */
      .el-button {
        padding: 8px 10px;
      }

      /* 设置按钮padding */
      .checkType {
        .el-select {
          .el-input {
            width: 100% !important;
          }
        }
      }
    }

    .el-input__inner[type="number"] {
      line-height: 14px;
      padding: 8px 15px;
    }

    //自定义必填样式
    .redstar:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .redstar:not(.is-no-asterisk) > .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }

  /* 弹出框 */
  .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__header {
        border-bottom: 1px solid #e7e7e7;
        word-break: break-all;
      }

      .el-dialog__body {
        padding-top: 20px;
        padding-bottom: 20px;
      }

      .el-dialog__footer {
        padding-top: 0;
      }
    }
  }
}
</style>
<style>
  .el-date-table td.start-date span {
    background-color: #1677ff !important;
  }
  .el-date-table td.end-date span {
    background-color: #1677ff !important;
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: #1677ff !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue